import styled from 'styled-components'

export const ActionIconWrapper = styled.div`
  display: inline-block;
  margin-left: 0.5rem;
`
